import { Title } from "@smartsuite/react-ui/lib/components/typography/Title/Title";

import { SidebarFieldButton } from "../SidebarFieldButton/SidebarFieldButton";
import { StaticElementCanvas } from "./types";

export interface SidebarElementListProps {
  onClick: (type: StaticElementCanvas) => void;
}

export const SidebarElementList: React.FC<SidebarElementListProps> = ({
  onClick,
}) => {
  return (
    <div className="sidebar-element-list">
      <Title weight="medium" size="xs" className="sidebar-element-list__title">
        Elements
      </Title>

      <div className="sidebar-element-list__items">
        <SidebarFieldButton
          iconName="horizontal-line-2"
          label="Line"
          className="sidebar-element-list__item"
          onClick={() => onClick(StaticElementCanvas.line)}
        />

        <SidebarFieldButton
          iconName="card-big"
          label="Rectangle"
          className="sidebar-element-list__item"
          onClick={() => onClick(StaticElementCanvas.rect)}
        />

        <SidebarFieldButton
          iconName="circle"
          label="Circle"
          className="sidebar-element-list__item"
          onClick={() => onClick(StaticElementCanvas.circle)}
        />

        <SidebarFieldButton
          iconName="text"
          label="Text"
          className="sidebar-element-list__item"
          onClick={() => onClick(StaticElementCanvas.text)}
        />

        <SidebarFieldButton
          iconName="link"
          iconSize="S"
          label="Link"
          className="sidebar-element-list__item"
          onClick={() => onClick(StaticElementCanvas.link)}
        />

        <SidebarFieldButton
          iconName="image"
          iconSize="S"
          label="Image"
          className="sidebar-element-list__item"
          onClick={() => onClick(StaticElementCanvas.image)}
        />
      </div>
    </div>
  );
};
